export default [
  {
    path: "/ai-training",
    component: () => import("@/views/aiTraining/layout"),
    children: [
      {
        path: "",
        name: "aiTraining",
        component: () => import("@/views/aiTraining/index"),
        meta: { title: "人工智能赋能职业教育教学关键要素改革的实践创新专题培训" }
      },
      {
        // 兼容旧预览链接，统一落到左右布局页
        path: "preview",
        redirect: to => ({
          name: "aiTraining",
          query: to.query.id ? { id: to.query.id } : {}
        })
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/aiTraining.js